import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from 'shared/hooks';

import { hasMorePagesSelector, loadMoreOffersThunk, loadMoreStatusSelector } from '../store';

export function useLoadMoreOffers() {
    const dispatch = useAppDispatch();
    const hasMorePages = useSelector(hasMorePagesSelector);
    const loadMoreStatus = useSelector(loadMoreStatusSelector);

    const loadMore = useCallback(() => {
        dispatch(loadMoreOffersThunk());
    }, [ dispatch ]);

    return {
        loadMore,
        hasMorePages,
        isLoadingMore: loadMoreStatus === 'pending'
    };
}
